/* ── Wrapper ── */
.wrapper {
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

/* ── Action panels (sit behind the content, hidden until swiping) ── */
.actionPanel {
  position: absolute;
  top: 0;
  bottom: 0;
  display: none;
  align-items: center;
  justify-content: center;
  min-width: 80px;
}

.actionPanelVisible {
  display: flex;
}

.actionLeft {
  left: 0;
  right: 50%;
  background: var(--nexus-purple);
  justify-content: flex-start;
  padding-left: var(--nexus-space-lg);
}

.actionRight {
  right: 0;
  left: 50%;
  background: var(--nexus-danger, #ef4444);
  justify-content: flex-end;
  padding-right: var(--nexus-space-lg);
}

/* ── Action button ── */
.actionBtn {
  display: flex;
  align-items: center;
  gap: var(--nexus-space-xs);
  padding: var(--nexus-space-sm) var(--nexus-space-md);
  border: none;
  background: transparent;
  color: #fff;
  font-size: var(--nexus-text-sm);
  font-weight: var(--nexus-weight-semibold);
  cursor: pointer;
  white-space: nowrap;
}

.deleteBtn {
  color: #fff;
}

.actionLabel {
  pointer-events: none;
}

.triggerHint {
  position: absolute;
  font-size: var(--nexus-text-xs);
  color: rgba(255, 255, 255, 0.7);
  font-weight: var(--nexus-weight-medium);
  pointer-events: none;
}

.actionLeft .triggerHint {
  left: var(--nexus-space-lg);
  top: var(--nexus-space-xs);
}

.actionRight .triggerHint {
  right: var(--nexus-space-lg);
  top: var(--nexus-space-xs);
}

/* ── Main content layer ── */
.content {
  position: relative;
  z-index: 1;
  background: var(--nexus-bg);
  touch-action: pan-y;
  will-change: transform;
}
